import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ListOfKSTEntity } from '../../store/entities/ListOfKSTEntity';
import { DataService } from '../services/data.service';
import { ContractEntity } from '../../store/entities/ContractEntity';

@Injectable({
	providedIn: 'root',
})
export class ContractsResolver implements Resolve<ContractEntity[]> {
	constructor(private readonly service: DataService) {}

	resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<ContractEntity[]> | Promise<ContractEntity[]> | ContractEntity[] {
		return this.service.getContracts().pipe(take(1));
	}
}
